/**
 * Helpful loop method for iterating over nodelists
 * 
 * @export
 * @param {string} section 
 * @returns {function} 
 */
export function forEach(array: NodeList | any[] | DOMTokenList | HTMLCollectionOf<any>, callback: Function, scope?: any) {
    for (let i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]);
    }
}


/**
 * Returns true if the queried path matches the URL path.
 * 
 * @param path The path to test against
 */
export function isPath(path: string) : boolean {
    return window.location.pathname === path;
}


/**
 * Returns a random whole number between min and max.
 * 
 * @param min 
 * @param max 
 */
export function getRandomNumber(min: number, max: number) {
    return Math.floor(Math.random() * (max - min) + min);
}


/**
 * Element selector, returns a single element.
 * 
 * @param selector The selector string
 */
export function get(selector: string, context: Element | HTMLElement | Document = document) : Element | undefined {
    if(!selector) return;
    
    if(selector.substr(0, 1) === '#') {
        return <Element>document.getElementById(selector.substr(1, selector.length - 1));
    } else {
        const element = context.querySelector(selector);
        if(element) {
            return element;
        } else {
            return undefined;
        }
    }
}


/**
 * Element selector, returns an array of elements.
 * 
 * @param selector The selector string
 */
export function getAll(selector: string, context: Element | HTMLElement | DocumentFragment | Document = document) : Element[] | undefined {
    if(!selector) return;
    
    const elements = context.querySelectorAll(selector);
    if(elements.length) {
        return [].slice.call(elements);
    } else {
        return undefined;
    }
}


/**
 * Returns the value of the provided query string
 *
 * @export
 * @param {string} name
 * @param {string} url
 * @returns {(string | null)}
 */
export function getParameterByName(name: string, url = window.location.href): string | null {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(url);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}


/**
 * Removes a query parameter from a URL string
 * 
 * @param parameter The parameter to remove
 * @param url The URL string to modify
 */
export function removeURLParameter(key: string, sourceURL: string = window.location.href) {
    let param;
    let paramsArr = [];
    let rtn           = sourceURL.split('?')[0];
    const queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';

    if(queryString !== '') {
        paramsArr = queryString.split('&');
        for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
            param = paramsArr[i].split('=')[0];
            if (param === key) {
                paramsArr.splice(i, 1);
            }
        }

        rtn = paramsArr.length ? `${rtn}?${paramsArr.join('&')}` : rtn;
    }

    return rtn;
}


/**
 * Converts an object to an array
 * 
 * @param any The iterable to conver to an rray 
 */
export function toArray(iterable: any): any[] {
    return [].slice.call(iterable);
}


/**
 * Returns true if any of the target ancestors contain the ancestorClass
 * 
 * @source https://stackoverflow.com/a/34605882/3062401
 * @param target 
 * @param ancestorClass 
 */
export function ancestorHasClass(target: Element, ancestorClass: string): boolean {
    if (!target) return false;
    let parent = <Node>target;

    do {

        if(parent === document) {
            break;
        }

        if ((parent as HTMLElement).classList.contains(ancestorClass)) {
            return true;
        }
  } while (parent = (parent.parentNode as HTMLElement)); // tslint:disable-line no-conditional-assignment

  return false;
}
